import { useRef } from "react";
import ModalPop from "../../home/ModalPop";

const RightQuick = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className="grid fixed right-0 bottom-24 lg:bottom-auto lg:right-6 lg:top-44 w-fit h-fit z-10 justify-items-center gap-2 lg:gap-4">
        <button type="button" onClick={openfunc} className="transition hover:scale-[1.02] active:scale-[0.98]">
          <img
            src="/images/quick1.png"
            alt="blog"
            className="!relative w-auto h-full max-h-24 lg:max-h-36 object-contain"
          />
        </button>

        <button
          type="button"
          onClick={() => window.open("https://open.kakao.com/o/szFKHIBi")}
          className="transition hover:scale-[1.02] active:scale-[0.98]"
        >
          <img
            src="/images/iconKakao.png"
            alt="blog"
            className="!relative w-auto h-full max-h-12 lg:max-h-16 object-contain"
          />
        </button>
        <button
          type="button"
          onClick={() => window.open("https://blog.naver.com/ansgo13")}
          className="transition hover:scale-[1.02] active:scale-[0.98]"
        >
          <img
            src="/images/iconBlog.png"
            alt="blog"
            className="!relative w-auto h-full max-h-12 lg:max-h-16 object-contain"
          />
        </button>
      </div>
    </>
  );
};

export default RightQuick;
